__turbopack_context__.v({
  "editButton": "_6SNqGq_editButton",
  "item": "_6SNqGq_item",
  "label": "_6SNqGq_label",
  "root": "_6SNqGq_root",
  "value": "_6SNqGq_value",
});
